import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';

interface Props {
  backUrl?: string | (() => void);
  children: React.ReactNode;
}

export type NavigationContextType = {
  backUrl: Props['backUrl'];
  setBackUrl: Dispatch<SetStateAction<Props['backUrl']>>;
};

const NavigationContext = createContext<NavigationContextType>({
  backUrl: undefined,
  setBackUrl: () => console.warn('no Navigation provider'),
});

export function useNavigationContext(): NavigationContextType {
  return useContext(NavigationContext);
}

export function NavigationProvider({ children }: Props): JSX.Element {
  const [backUrl, setBackUrl] = useState<string | (() => void)>();

  return <NavigationContext.Provider value={{ backUrl, setBackUrl }}>{children}</NavigationContext.Provider>;
}
